import FileUploadManager from 'Lib/fileUploadManager';

// Default selectors for UserProfileForm
const SELECTORS = {
  FORM: '.form-user-profile',
  AVATAR_FORM_GROUP: '.form-user-profile__avatar',
  AVATAR: '.avatar',
  AVATAR_PLACEHOLDER: '.avatar__placeholder',
  AVATAR_INPUT: '#user_avatar',
  SUBMIT_BUTTON: '[type="submit"]'
};

const CLASS_NAME = {
  UPLOADING: 'form-user-profile__avatar--uploading'
};

export const DEFAULT_OPTIONS = {
  className: CLASS_NAME,
  selectors: SELECTORS
};

class UserProfileForm {
  /**
   * Initializer
   *
   * @param {Element} form - user profile form
   * */
  constructor(form) {
    // Initialise attributes

    // Form Node
    this.form = form;
    this.avatarFormGroup = this.form.querySelector(SELECTORS['AVATAR_FORM_GROUP']);
    this.avatarPreviewElement = this.form.querySelector(SELECTORS['AVATAR']);
    this.avatarPlaceholder = this.form.querySelector(SELECTORS['AVATAR_PLACEHOLDER']);
    this.avatarInputField = this.form.querySelector(SELECTORS['AVATAR_INPUT']);
    this.formSubmitButton = this.form.querySelector(SELECTORS['SUBMIT_BUTTON']);
    this.isUploading = false;

    // Bind functions
    this.openFileUploader = this.openFileUploader.bind(this);
    this.fileUploadStartHandler = this.fileUploadStartHandler.bind(this);
    this.fileUploadSuccessHandler = this.fileUploadSuccessHandler.bind(this);

    this._setup();
  }

  // Event Handlers

  /**
   * Event handler to open the file uploader.
   *
   * @param {Event} event - click event to open the file uploader.
   * */
  openFileUploader(event) {
    event.preventDefault();

    if (this.isUploading) { return; }

    FileUploadManager.pick({
      imagesOnly: true,
      onFileUploadStart: this.fileUploadStartHandler,
      onFileUploadSuccess: this.fileUploadSuccessHandler
    });
  }

  /**
   * Callback to be triggered when the upload starts.
   *
   * 1) Sets `isUploading` to `true`
   * 2) Adds `form__group--avatar-uploading` to the avatar form group. This shows the loading animation.
   * 3) Disables the form submit button.
   * */
  fileUploadStartHandler() {
    this.isUploading = true;
    this.avatarFormGroup.classList.add(CLASS_NAME['UPLOADING']);
    this.formSubmitButton.disabled = true;
  }

  /**
   * Callback to be triggered when the upload finishes.
   *
   * 1) Sets `isUploading` to `false`.
   * 2) Removes the loading animation, if any.
   * 3) Adds the newly uploaded image in avatar preview.
   * 4) Enables the form submit button.
   *
   * @param {Object} file - file object that was uploaded.
   *    https://uploadcare.com/docs/api_reference/javascript/files_uploads/#file-info
   * */
  fileUploadSuccessHandler(file) {
    this.isUploading = false;

    let fallbackIcon = this.avatarPreviewElement.querySelector('svg');
    fallbackIcon && this.avatarPreviewElement.removeChild(fallbackIcon);

    this.avatarPreviewElement.style.backgroundImage = `url(${file.cdnUrl})`;
    this.avatarPreviewElement.style.backgroundSize = '100% 100%';
    this.avatarInputField.value = file.cdnUrl;
    if (this.avatarPlaceholder !== null && this.avatarPlaceholder !== undefined) {
      this.avatarPlaceholder.style.display = 'none';
    }

    this.avatarFormGroup.classList.remove(CLASS_NAME['UPLOADING']);
    this.formSubmitButton.disabled = false;
  }

  // Private Methods

  _setup() {
    this._addEventListeners();
  }

  /**
   * Adds all the required event listeners.
   * */
  _addEventListeners() {
    this.avatarFormGroup.addEventListener('click', this.openFileUploader);
  }
}

export default UserProfileForm;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/userProfileForm/index.js